import styled from "styled-components"; 


export const ContainerModalAtencionSinTurno = styled.div`
    width: 365px;
    height: 200px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    margin: auto;
    .bold {
        font-weight: 500;
    }
    .container-btn {
        display: flex;
        gap: 10px;
    }
    .cancelar {
        width: 142px;
        height: 40px;
        border-radius: 8px;
        background: none;
        border: 1px solid var(--color-latex30);
        color: var(--color-latex30);
        font-size: 16px;
        font-weight: 500;
        box-shadow: 0 100px 80px rgb(0 0 0 / 7%), 0 41.7776px 33.4221px rgb(0 0 0 / 5%), 0 22.3363px 17.869px rgb(0 0 0 / 4%), 0 12.5216px 10.0172px rgb(0 0 0 / 4%), 0 6.6501px 5.32008px rgb(0 0 0 / 3%), 0 2.76726px 2.21381px rgb(0 0 0 / 2%);
    }
    .tomar {
        width: 180px;
        height: 40px;
        border-radius: 8px;
        background-color: var(--color-latex10);
        color: var(--color-white);
        font-size: 16px;
        font-weight: 500; 
    }
    /* @keyframes animation {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    animation: animation 1s ease-in-out 1; */
`; 